import useAdEditorContext from 'hooks/context/ad-editor-context';
import { useMutation } from 'hooks/sympl-mutation';
import { UPDATE_LIVE_ADS } from 'graphql/campaign-values/mutations';
import { sendLiveAdsUpdate } from 'utils/keptLiveUpdate';

/**
 * "Update this ad" / "Update all" for one campaign. On a running campaign the
 * server keeps the update for "Publish changes" (SYM-6757); the sidebar then
 * recounts and the open ad is drawn again with the current details.
 */
const useLiveAdsUpdate = (vacancyId: number | null | undefined) => {
  const [update] = useMutation<
    { updateLiveAds: { updated: number; kept?: number } },
    { vacancyId: number; input: { ad_variant_ids?: number[] } }
  >(UPDATE_LIVE_ADS);
  const { refreshTemplatePreview } = useAdEditorContext();

  return (ids?: number[]) =>
    sendLiveAdsUpdate(update, vacancyId as number, refreshTemplatePreview, ids);
};

export default useLiveAdsUpdate;
